import {PermissionUtil} from "../utils/permission.util";
import {ApiModules, ApiOperations, OrganisationUserRoles} from "@qid/core";

export const PermissionList = [

  {
    module: 'Account',
    permissions: [
      {
        name: 'View Account details',
        permission: PermissionUtil.PermissionName(ApiModules.Organisation, ApiOperations.read),
      },
      {
        name: 'Update Account details',
        permission: PermissionUtil.PermissionName(ApiModules.Organisation, ApiOperations.update),
        minimumRole: OrganisationUserRoles.EDITOR
      },
      {
        name: 'Delete Account',
        permission: PermissionUtil.PermissionName(ApiModules.Organisation, ApiOperations.delete),
        minimumRole: OrganisationUserRoles.ADMIN
      }
    ]
  },
  {
    module: 'Forms',
    permissions: [
      {
        name: 'View All Forms',
        permission: PermissionUtil.PermissionName(ApiModules.CollectionTemplates, ApiOperations.readAll)
      },
      {
        name: 'Create a Form',
        permission: PermissionUtil.PermissionName(ApiModules.CollectionTemplates, ApiOperations.create)
      },
      {
        name: 'Update a Form',
        permission: PermissionUtil.PermissionName(ApiModules.CollectionTemplates, ApiOperations.update)
      },
      {
        name: 'Delete a From',
        permission: PermissionUtil.PermissionName(ApiModules.CollectionTemplates, ApiOperations.delete),
        minimumRole: OrganisationUserRoles.EDITOR
      }
    ]
  },
  {
    module: 'Share',
    permissions: [
      {
        name: 'View All Shares',
        permission: PermissionUtil.PermissionName(ApiModules.Share, ApiOperations.readAll)
      },
      {
        name: 'Create Share',
        permission: PermissionUtil.PermissionName(ApiModules.Share, ApiOperations.create)
      },
      {
        name: 'Update Share',
        permission: PermissionUtil.PermissionName(ApiModules.Share, ApiOperations.update)
      },
      {
        name: 'Delete Share',
        permission: PermissionUtil.PermissionName(ApiModules.Share, ApiOperations.delete),
        minimumRole: OrganisationUserRoles.EDITOR
      }
    ]
  },
  {
    module: 'Members',
    permissions: [
      {
        name: 'View All Members',
        permission: PermissionUtil.PermissionName(ApiModules.OrganisationUser, ApiOperations.readAll)
      },
      {
        name: 'Add new Member',
        permission: PermissionUtil.PermissionName(ApiModules.OrganisationUser, ApiOperations.create),
        minimumRole: OrganisationUserRoles.EDITOR
      },
      {
        name: 'Update a Member',
        permission: PermissionUtil.PermissionName(ApiModules.OrganisationUser, ApiOperations.update),
        minimumRole: OrganisationUserRoles.EDITOR
      },
      {
        name: 'Delete a Member',
        permission: PermissionUtil.PermissionName(ApiModules.OrganisationUser, ApiOperations.delete),
        minimumRole: OrganisationUserRoles.EDITOR
      }
    ]
  },
  {
    module: 'Documents',
    permissions: [
      {
        name: 'View a Document',
        permission: PermissionUtil.PermissionName(ApiModules.Document, ApiOperations.read)
      },
      {
        name: 'View all Documents',
        permission: PermissionUtil.PermissionName(ApiModules.Document, ApiOperations.readAll)
      }
    ]
  },
  {
    module: 'Export',
    permissions: [
      {
        name: 'Export All',
        permission: PermissionUtil.PermissionName(ApiModules.Share, ApiOperations.exportAll)
      }
    ]
  },
  {
    module: 'Integration',
    permissions: [
      {
        name: 'View all Keys',
        permission: PermissionUtil.PermissionName(ApiModules.AuthKey, ApiOperations.readAll)
      },
      {
        name: 'Create New Key',
        permission: PermissionUtil.PermissionName(ApiModules.AuthKey, ApiOperations.create)
      },
      {
        name: 'Delete a Key',
        permission: PermissionUtil.PermissionName(ApiModules.AuthKey, ApiOperations.delete)
      }
    ]
  },
]
